import apiClient from '@/services/rest-api-identity/apiClient'

const baseEndpoint = '/send-invitation-user'

export const sendInvitationUser = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data,
  })

  return response?.data
}
